import { Flame } from "lucide-react";

const ITEMS = [
    "Cuit à la Braise",
    "Pain Fait Maison",
    "Frites Maison",
    "Le Goût du Feu de Bois",
    "Lun–Sam · 11h30 — 22h30",
    "Petit Veau Athis-Mons",
];

export default function SlowMarquee() {
    const row = [...ITEMS, ...ITEMS];
    return (
        <div
            data-testid="editorial-marquee"
            className="relative overflow-hidden border-y border-rose-600/25 bg-gradient-to-r from-rose-950/40 via-[#160608] to-rose-950/40 py-5"
        >
            <div className="animate-marquee flex w-max items-center gap-10">
                {row.map((item, i) => (
                    <span key={i} className="flex items-center gap-10">
                        <span className="font-display text-lg font-black uppercase tracking-tight text-zinc-100 sm:text-2xl">
                            {item}
                        </span>
                        <Flame className="h-5 w-5 shrink-0 text-rose-500" />
                    </span>
                ))}
            </div>
        </div>
    );
}
